import React from "react";
import { useLanguage } from "../../context/LanguageContext";
import {
  unsolvedvehicales,
  derhumSign,
  soldvehical,
  totavehical,
  totalearning,
} from "../../utils/data";

const StatCard = ({
  title,
  value,
  percentage,
  icon,
  bgStyle,
  svgPath,
  svgPosition,
  aedicon,
}) => (
  <div
    className='relative rounded-2xl p-6  text-white overflow-hidden'
    style={{ background: bgStyle, height: "177px" }}
  >
    {/* Background SVG with custom position */}
    <div className={`${svgPosition} md:h-[250px] opacity-40`}>
      <svg className='w-[15rem] h-[15rem]' viewBox='0 0 243 154' fill='none'>
        <path
          d={svgPath}
          stroke='white'
          strokeOpacity='0.5'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeDasharray='8 4'
        />
      </svg>
    </div>

    {/* Content */}
    <div className='relative  z-10'>
      <div className='flex items-start justify-between mb-4'>
        <div className='bg-white h-[54px] md:h-[64px] w-[64px] flex justify-center items-center rounded-3xl'>
          {icon}
        </div>
        <div className='bg-transparent border border-white p-3 rounded-full text-sm md:text-[16px] font-semibold'>
          {percentage}
        </div>
      </div>
      <h3 className='text-lg md:text-[20px] font-medium mb-1'>{title}</h3>
      <p className='text-2xl flex items-center gap-2 md:text-[32px] font-bold'>
        {aedicon}
        {value}
      </p>
    </div>
  </div>
);

const SellerDashboard = () => {
  const { translate, language } = useLanguage();
  const isRTL = language === "ar";

  return (
    <div dir={isRTL ? "rtl" : "ltr"} lang={language}>
      <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8'>
        <StatCard
          title={translate("dashboard.stats.totalEarning")}
          value='AED 1,000'
          percentage='+ 2.08%'
          aedicon={<>{derhumSign}</>}
          icon={totalearning}
          bgStyle='linear-gradient(280.11deg, #FF4A33 -12.68%, #E95923 100.28%)'
          svgPath='M0.999699 1.00016C26.9471 6.49534 97.1448 21.4249 87.4724 53.7082C80.8686 75.7493 56.5904 63.6007 64.7409 39.7722C72.8914 15.9437 115.65 15.7066 119.4 64.9586M119.4 64.9586L111.04 59.6056M119.4 64.9586L126.125 53.5401'
          svgPosition='absolute left-[6rem] top-0'
        />
        <StatCard
          title={translate("dashboard.stats.totalVehicles")}
          value='2'
          percentage='+ 2.08%'
          icon={totavehical}
          bgStyle='linear-gradient(280.11deg, #C06CEA -12.68%, #A266F3 100.28%)'
          svgPath='M94 145C95.8713 130.63 110.343 103.664 153.257 110.76C196.172 117.855 213.001 83.8763 216.05 66M216.05 66L206.277 73.4256M216.05 66L220 76.7259'
          svgPosition='absolute left-[50px] top-[-29px]'
        />
        <StatCard
          title={translate("dashboard.stats.soldVehicles")}
          value='2'
          percentage='+ 2.08%'
          icon={soldvehical}
          bgStyle='linear-gradient(280.11deg, #828EF1 -12.68%, #8684F2 100.28%)'
          svgPath='M120.484 118.414C110.796 126.656 88.9216 139.344 78.9244 124.162C68.9272 108.98 79.3952 85.8114 85.8787 76.1247C91.9892 67.2996 95.193 50.4551 59.1227 53.6804C14.0348 57.712 11.039 34.2721 8.43518 5.15247M18.4909 11.9301L8.11472 1.56852L1.52713 13.447'
          svgPosition='absolute right-[-20px] bottom-[-55px]'
        />
        <StatCard
          title={translate("dashboard.stats.unsoldVehicles")}
          value='4'
          percentage='- 2.08%'
          icon={unsolvedvehicales}
          bgStyle='linear-gradient(280.11deg, #24CFBA -12.68%, #16B9DA 100.28%)'
          svgPath='M1.97656 1.09766C0.373569 17.8937 9.66506 52.2038 59.6554 55.0739C109.646 57.944 119.776 100.819 118.59 121.897M118.59 121.897L109.537 110.976M118.59 121.897L125.788 110.722'
          svgPosition='absolute left-[110px] top-[-20px]'
        />
      </div>

      <div className='flex w-full gap-6 mb-8'>
        {/* Left Panel - 65% width */}
        <div className='w-2/3 space-y-6'>
          {/* Recent Sold Cars Section */}
          <div className='bg-white rounded-lg shadow p-1'>
            <div className='flex items-center justify-between mb-1 bg-orange-600 rounded-t-lg p-4'>
              <h2 className='text-lg font-semibold text-white'>
                {translate("dashboard.stats.recentSoldCars")}
              </h2>
              <a
                href='#'
                className='text-white hover:text-gray-300 text-sm font-medium'
              >
                {translate("dashboard.stats.showAll")}
              </a>
            </div>
            <div className='overflow-x-auto'>
              <table className='w-full'>
                <thead className='bg-gray-200  text-bg-darkgray'>
                  <tr className='border-b border-gray-200'>
                    <th
                      className={`${
                        isRTL ? "text-right" : "text-left"
                      } py-3 px-2 text-sm font-medium`}
                    >
                      {translate("dashboard.stats.vehicleInfo")}
                    </th>
                    <th
                      className={`${
                        isRTL ? "text-right" : "text-left"
                      } py-3 px-2 text-sm font-medium`}
                    >
                      {translate("dashboard.stats.lotNumber")}
                    </th>
                    <th
                      className={`${
                        isRTL ? "text-right" : "text-left"
                      } py-3 px-2 text-sm font-medium`}
                    >
                      {translate("dashboard.stats.vinNumber")}
                    </th>
                    <th
                      className={`${
                        isRTL ? "text-right" : "text-left"
                      } py-3 px-2 text-sm font-medium`}
                    >
                      {translate("dashboard.stats.sellingPrice")}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {[1, 2, 3, 4].map((item, index) => (
                    <tr
                      key={index}
                      className='border-b border-gray-100 hover:bg-gray-50'
                    >
                      <td className='py-3 px-2'>
                        <div
                          className={`flex items-center ${
                            isRTL ? "space-x-reverse" : "space-x-3"
                          }`}
                        >
                          <div className='w-12 h-12 bg-gray-200 rounded-lg flex items-center justify-center'>
                            <span className='text-xs text-gray-500'>
                              {translate("dashboard.stats.allPhotos")}
                            </span>
                          </div>
                          <div>
                            <p className='font-medium text-gray-900'>
                              Hyundai Santa Cruz Sel
                            </p>
                            <p className='text-sm text-gray-500'>
                              {translate("dashboard.stats.model")} 2022
                            </p>
                          </div>
                        </div>
                      </td>
                      <td className='py-3 px-2 text-sm text-gray-600'>
                        Lot #56229765
                      </td>
                      <td className='py-3 px-2 text-sm text-gray-600'>
                        VIN #MG006897
                      </td>
                      <td className='py-3 px-2'>
                        <span
                          className={`text-gray-500 ${isRTL ? "ml-1" : "mr-1"}`}
                        >
                          AED
                        </span>
                        <span className='font-semibold text-gray-900'>
                          32,010
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Recent Service Charges Section */}
          {/* <div className='bg-white rounded-lg shadow p-1'>
            <div className='flex items-center justify-between mb-4 bg-orange-600 rounded-t-lg p-4'>
              <h2 className='text-lg font-semibold text-white'>
                {translate("dashboard.stats.recentServiceCharges")}
              </h2>
              <a
                href='#'
                className='text-white hover:text-gray-300 text-sm font-medium'
              >
                {translate("dashboard.stats.showAll")}
              </a>
            </div>
            <div className='overflow-x-auto'>
              <table className='w-full'>
                <thead className='bg-gray-200  text-bg-darkgray'>
                  <tr className='border-b border-gray-200'>
                    <th
                      className={`${
                        isRTL ? "text-right" : "text-left"
                      } py-3 px-2 text-sm font-medium`}
                    >
                      {translate("dashboard.stats.vehicleInfo")}
                    </th>
                    <th
                      className={`${
                        isRTL ? "text-right" : "text-left"
                      } py-3 px-2 text-sm font-medium`}
                    >
                      {translate("dashboard.stats.lotNumber")}
                    </th>
                    <th
                      className={`${
                        isRTL ? "text-right" : "text-left"
                      } py-3 px-2 text-sm font-medium`}
                    >
                      {translate("dashboard.stats.vinNumber")}
                    </th>
                    <th
                      className={`${
                        isRTL ? "text-right" : "text-left"
                      } py-3 px-2 text-sm font-medium`}
                    >
                      {translate("dashboard.stats.serviceCharges")}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {[1, 2].map((item, index) => (
                    <tr
                      key={index}
                      className='border-b border-gray-100 hover:bg-gray-50'
                    >
                      <td className='py-3 px-2'>
                        <div
                          className={`flex items-center ${
                            isRTL ? "space-x-reverse" : "space-x-3"
                          }`}
                        >
                          <div className='w-12 h-12 bg-gray-200 rounded-lg flex items-center justify-center'>
                            <span className='text-xs text-gray-500'>
                              {translate("dashboard.stats.allPhotos")}
                            </span>
                          </div>
                          <div>
                            <p className='font-medium text-gray-900'>
                              Hyundai Santa Cruz Sel
                            </p>
                            <p className='text-sm text-gray-500'>
                              {translate("dashboard.stats.model")} 2022
                            </p>
                          </div>
                        </div>
                      </td>
                      <td className='py-3 px-2 text-sm text-gray-600'>
                        Lot #56229765
                      </td>
                      <td className='py-3 px-2 text-sm text-gray-600'>
                        VIN #MG006897
                      </td>
                      <td className='py-3 px-2'>
                        <span
                          className={`text-gray-500 ${isRTL ? "ml-1" : "mr-1"}`}
                        >
                          AED
                        </span>
                        <span className='font-semibold text-gray-900'>320</span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div> */}
        </div>

        {/* Right Panel - 35% width */}
        <div className='w-1/3'>
          <div className='bg-white rounded-lg shadow p-6'>
            <div className='flex items-center justify-between mb-4'>
              <div>
                <h2 className='text-xl font-semibold text-gray-800'>
                  {translate("dashboard.stats.earningStatistic")}
                </h2>
                <p className='text-sm text-gray-500'>
                  {translate("dashboard.stats.trackYourEarning")}
                </p>
              </div>
              <select
                className={`text-sm border border-gray-300 rounded-lg px-3 py-1 bg-white ${
                  isRTL ? "text-right" : ""
                }`}
              >
                <option>{translate("dashboard.stats.thisMonth")}</option>
              </select>
            </div>

            {/* Donut Chart */}
            <div className='flex justify-center mb-6'>
              <div className='relative w-32 h-32'>
                <svg
                  className='w-32 h-32 transform -rotate-90'
                  viewBox='0 0 32 32'
                >
                  {/* Orange segment - 40% */}
                  <circle
                    cx='16'
                    cy='16'
                    r='14'
                    fill='none'
                    stroke='#FF6B35'
                    strokeWidth='4'
                    strokeDasharray='35.2 88'
                    strokeDashoffset='0'
                  />
                  {/* Green segment - 35% */}
                  <circle
                    cx='16'
                    cy='16'
                    r='14'
                    fill='none'
                    stroke='#4CAF50'
                    strokeWidth='4'
                    strokeDasharray='30.8 88'
                    strokeDashoffset='-35.2'
                  />
                  {/* Teal segment - 16% */}
                  <circle
                    cx='16'
                    cy='16'
                    r='14'
                    fill='none'
                    stroke='#00BCD4'
                    strokeWidth='4'
                    strokeDasharray='14.08 88'
                    strokeDashoffset='-66'
                  />
                  {/* Purple segment - 10% */}
                  <circle
                    cx='16'
                    cy='16'
                    r='14'
                    fill='none'
                    stroke='#9C27B0'
                    strokeWidth='4'
                    strokeDasharray='8.8 88'
                    strokeDashoffset='-80.08'
                  />
                  {/* Inner circle */}
                  <circle
                    cx='16'
                    cy='16'
                    r='8'
                    fill='#F5F5F5'
                    stroke='#E0E0E0'
                    strokeWidth='1'
                    strokeDasharray='2 2'
                  />
                </svg>
              </div>
            </div>

            {/* Earning Summary */}
            <div className='space-y-3'>
              <div className='flex justify-between items-center'>
                <span className='text-sm text-gray-600'>
                  {translate("dashboard.stats.totalBalance")}
                </span>
                <span className='font-semibold text-gray-900'>AED 20,000</span>
              </div>
              <div className='flex justify-between items-center'>
                <span className='text-sm text-gray-600'>
                  {translate("dashboard.stats.serviceCharges")}
                </span>
                <span className='font-semibold text-gray-900'>AED 420</span>
              </div>
              <div className='flex justify-between items-center'>
                <span className='text-sm text-gray-600'>
                  {translate("dashboard.stats.totalStorageFee")}
                </span>
                <span className='font-semibold text-gray-900'>AED 1,000</span>
              </div>
              <div className='flex justify-between items-center pt-2 border-t border-gray-200'>
                <span className='text-sm font-medium text-gray-800'>
                  {translate("dashboard.stats.totalEarning")}
                </span>
                <span className='text-lg font-bold text-blue-600'>
                  AED 32,000
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SellerDashboard;
